@if (dataSource$ | async; as documents) {
<div #rootElement cdkDropListGroup [cdkDropListGroupDisabled]="(isBrowsingRootFolder$ | async) === true">
  <input type="file" class="file-input" multiple (change)="handleUploadFile($event.target.files)" #fileUpload />
  <div class="table-toolbar">
    <div class="breadcrumb">
      @if (crumbs$ | async; as crumbs) {
      @for (crumbName of crumbs; track $index; let index = $index, isFirst = $first, isLast = $last) {
        @if (!isFirst) {
        <mat-icon class="separator">chevron_right</mat-icon>
        }
        <div
          class="crumb is-folder"
          [class.is-first]="isFirst"
          [class.is-last]="isLast"
          cdkDropList
          [cdkDropListData]="{index, crumbs}"
          (cdkDropListDropped)="droppedOnCrumb($event)"
          (click)="!isLast && onBreadcrumbClick(index, crumbs)"
        >
          @if (isFirst) {
          <mat-icon>home</mat-icon>HOME } @if (!isFirst) {
          {{ crumbName | uppercase }}
          }
        </div>
      }
      }
    </div>
    @if ((hasPolicySharepointFileManagementEcab$ | async) && (dynamicUrlSharePoint$ | async); as sharePointUrl) {
    <sibat-link-button
      data-testid="sharepointUrl"
      [href]="sharePointUrl"
      target="_blank"
      [external]="true"
      [label]="'SharePoint'"
    ></sibat-link-button>
    }
  </div>
  @for (error of errors; track error) {
  <div class="error-msg">
    <mat-icon>error</mat-icon>
    <p>
      @switch (error.code) { @case (errorCodes.maxSizeExceeded) {
      <span> {{ error.fileName }}: {{ 'building.documents.maxSizeExceeded' | transloco }} </span>
      } }
    </p>
  </div>
  }
  <div
    class="root-drop-zone"
    sibatDragNDrop
    [active]="(isBrowsingRootFolder$ | async) === false && (isEditableFolder$ | async)"
    (fileDropped)="handleUploadFile($event)"
  >
    <table mat-table [dataSource]="documents" class="document-table">
      <ng-container matColumnDef="node">
        <th mat-header-cell *matHeaderCellDef class="table-header">
          <button mat-icon-button disabled>
            <mat-icon>attach_file</mat-icon>
          </button>
          <span class="name-column-header">{{ 'building.documents.nameColumn' | transloco }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          sibatDragNDrop
          [active]="isEditableFolder$ | async"
          [applyHover]="element.isFolder"
          [ngClass]="{ 'is-file': !element.isFolder, 'is-folder': element.isFolder }"
          cdkDropList
          [cdkDropListData]="element"
          [cdkDropListSortingDisabled]="true"
          (cdkDropListDropped)="droppedOnFolder($event)"
          (fileDropped)="handleUploadFile($event, element)"
        >
          <div class="content" cdkDrag [cdkDragData]="element" [cdkDragBoundary]="rootElement" (click)="onNodeClick(element)">
            <button mat-icon-button>
              @if (element.isFolder && !element.isEmpty) {
              <mat-icon>folder</mat-icon>
              } @if (element.isFolder && element.isEmpty) {
              <mat-icon class="empty-folder" svgIcon="folder-no-files"> </mat-icon>
              } @if (!element.isFolder) {
              <mat-icon>cloud_download</mat-icon>
              }
            </button>
            <button mat-button class="navigation-button">{{ element.name }}</button>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-header">
          @if ((isBrowsingRootFolder$ | async) === false && (isEditableFolder$ | async)) {
          <mat-icon (click)="onCreateSubFolderClick()"> create_new_folder</mat-icon>
          }
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (element.isFolder) { @if (isEditableFolder$ | async) {
            <button mat-menu-item>
              <mat-icon>add</mat-icon>
              <span>{{ 'building.documents.addFile' | transloco }}</span>
              <input class="add-file" type="file" multiple (change)="handleUploadFile($event.target.files, element)" />
            </button>
            } } @else {
            <button mat-menu-item (click)="downloadFile(element.name)">
              <mat-icon>cloud_download</mat-icon>
              <span>{{ 'building.documents.download' | transloco }}</span>
            </button>
            @if (hasPolicySharepointFileManagementEcab$ | async) {
            <button mat-menu-item (click)="confirmRemoveFile(element)">
              <mat-icon>delete</mat-icon>
              <span>{{ 'building.documents.delete' | transloco }}</span>
            </button>
            <button mat-menu-item (click)="renameFile(element)">
              <mat-icon>edit</mat-icon>
              <span>{{ 'building.documents.rename' | transloco }}</span>
            </button>
            } }
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      @if (hasPolicySharepointFileManagementEcab$ | async) {
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="3" sibatDragNDrop [active]="isEditableFolder$ | async" (fileDropped)="handleUploadFile($event)">
          <mat-icon class="folder-off-icon">folder_off</mat-icon>
        </td>
      </tr>
      }
    </table>
    @if ((isBrowsingRootFolder$ | async) === false && (isEditableFolder$ | async)) {
    <div class="drop-zone-bottom">
      <div
        class="drop-zone"
        sibatDragNDrop
        [active]="isEditableFolder$ | async"
        (fileDropped)="handleUploadFile($event)"
        (click)="fileUpload.click()"
      >
        <mat-icon>upload</mat-icon> {{ 'building.documents.addFile' | transloco }}
      </div>
    </div>
    }
  </div>
</div>
}
